export default __webpack_public_path__ + "static/media/slide3.731cb4c3.webp";